"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const normalizeBaseUrl = (value) => {
    const raw = (value || 'https://aibprtsk.com/').trim();
    const withSlash = raw.endsWith('/') ? raw : `${raw}/`;
    return withSlash.endsWith('admin_api/v1/')
        ? withSlash
        : `${withSlash}admin_api/v1/`;
};
const preconnectCodes = new Set([
    'CERT_HAS_EXPIRED', 'DEPTH_ZERO_SELF_SIGNED_CERT', 'EAI_AGAIN', 'ECONNREFUSED',
    'EHOSTUNREACH', 'ENETUNREACH', 'ENOTFOUND', 'ERR_SSL_CERT_AUTHORITY_INVALID',
    'ERR_TLS_CERT_ALTNAME_INVALID', 'SELF_SIGNED_CERT_IN_CHAIN', 'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
]);
const idempotentMethods = new Set(['delete', 'get', 'head', 'options', 'put']);
const gatewayStatuses = new Set([502, 503, 504, 521, 522, 523, 524, 525, 526]);
const primaryBaseUrl = normalizeBaseUrl(process.env.KEITARO_ADMIN_API_URL || process.env.KEITARO_API_URL);
const fallbackOrigin = String(process.env.KEITARO_API_FALLBACK_URL || '').trim().replace(/\/+$/, '');
const http = axios_1.default.create({
    baseURL: primaryBaseUrl,
    headers: {
        "Api-Key": process.env.KEITARO_API_KEY || `a5369b1016aa6bd6453751a393b157b4`,
    },
});
if (fallbackOrigin) {
    http.interceptors.response.use(undefined, async (error) => {
        const config = (error?.config || {});
        if (config.__keitaroFallbackAttempted)
            throw error;
        const status = Number(error?.response?.status || 0);
        const code = String(error?.code || '').toUpperCase();
        const method = String(config.method || 'get').toLowerCase();
        const retryable = status
            ? gatewayStatuses.has(status)
            : preconnectCodes.has(code) || (['ECONNABORTED', 'ECONNRESET', 'ETIMEDOUT'].includes(code) && idempotentMethods.has(method));
        if (!retryable)
            throw error;
        const primaryUrl = new URL(http.getUri(config), primaryBaseUrl);
        const fallbackUrl = new URL(fallbackOrigin);
        fallbackUrl.pathname = primaryUrl.pathname;
        fallbackUrl.search = primaryUrl.search;
        config.__keitaroFallbackAttempted = true;
        config.baseURL = undefined;
        config.url = fallbackUrl.toString();
        config.params = undefined;
        console.warn('[keitaro-fallback] retrying Admin API through direct tracker origin', {
            primaryOrigin: primaryUrl.origin,
            fallbackOrigin: fallbackUrl.origin,
            method: method.toUpperCase(),
            path: fallbackUrl.pathname,
            code: error?.code || null,
            status: error?.response?.status || null,
        });
        return http.request(config);
    });
}
exports.default = http;
